// hooks/useFetchTransactionStatus.ts
import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

interface IQueryParams {
  [key: string]: string | number | boolean;
}

const useFetchTransactionStatus = (queryParams: IQueryParams = {}) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [transaction, setTransaction] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTransactionStatus = async () => {
      if (!isAuthenticated) return; // Esperar a que el usuario esté autenticado

      setLoading(true);
      setError(null);

      try {
        const tk = await getAccessTokenSilently();

        const urlParams = new URLSearchParams(
          queryParams as Record<string, string>
        ).toString();

        const response = await axios.get<{ response: any }>(
          `${apiUrl}/api/v1/withdrawaltransaction/user?${urlParams}`,
          {
            headers: {
              Authorization: `Bearer ${tk}`,
            },
          }
        );

        setTransaction(response.data.response.data ?? []); // <-- proteger en caso de que no haya data
      } catch (err) {
        console.error(err);
        setError("Error fetching withdrawal transactions");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactionStatus();
  }, [isAuthenticated, getAccessTokenSilently, JSON.stringify(queryParams)]);

  return { transaction, loading, error };
};

export default useFetchTransactionStatus;
